import { ButtonAppearance } from '@app/shared/components/button/button-enums';
import Button from '@app/shared/components/button/Button';
import classNames from 'classnames';
import { FC } from 'react';
import styles from '@app/modules/projects/dashboard/shared/per-year-capital-structure/per-year-capital-structure-chart.module.scss';

export interface LegendItem {
  iconModifier: string;
  label: string;
  visible: boolean;
}

const PARENT_CLASSNAME = 'total-equity-chart';

const ChartLegend: FC<{ items: LegendItem[] }> = ({ items }) => (
  <div className={styles[`${PARENT_CLASSNAME}__legend`]}>
    {items
      .filter((item) => item.visible)
      .map((item) => (
        <Button key={item.iconModifier} appearance={ButtonAppearance.CLEAN} ignoreReadOnly>
          <span
            className={classNames([
              styles[`${PARENT_CLASSNAME}__icon`],
              styles[`${PARENT_CLASSNAME}__icon--${item.iconModifier}`],
            ])}
          />
          {item.label}
        </Button>
      ))}
  </div>
);

export default ChartLegend;
